<template>
  <BaseBigNumber
      :number="number"
      :title="title"
      :subnumber="subnumber"
      :subnumber-description="subnumberDescription"
      :tooltip="tooltip"
      :type="type"
      :loading="loading"
      v-bind="$attrs"
  />
</template>

<script>
import BaseBigNumber from "@/components/shared/BaseBigNumber.vue";
import SubscriptionsReportService from "@/services/resources/SubscriptionsReportService";

const subscriptionsReportService = SubscriptionsReportService.build();

export default {
  name: "SubscriptionBigNumber",
  inheritAttrs: false,
  components: {BaseBigNumber},
  props: {
    title: {
      type: String,
      required: true
    },
    subnumberDescription: {
      type: String,
      required: false
    },
    tooltip: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false,
      default: "info",
      validator: function (value) {
        return ["info", "warning", "danger"].includes(value);
      }
    },
  },
  data() {
    return {
      number: "R$ 0,00",
      subnumber: null,
      loading: true
    };
  },
  created() {
    this.updateBigNumber();
  },
  watch: {
    '$store.getters.getFilters': {
      handler() {
        this.updateBigNumber();
      },
      deep: true
    }
  },
  methods: {
    updateBigNumber() {
      if (null === this.$attrs.id) {
        return;
      }

      let filters = this.$store.getters.getFilters || {};
      this.loading = true;
      subscriptionsReportService.bigNumber(this.$attrs.id, filters).then(response => {
        this.number = this.toSafeString(response.data.bignumber);
        this.subnumber = this.toSafeString(response.data.subnumber);
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    toSafeString(value) {
      if (null === value || undefined === value) {
        return "";
      }
      return String(value);
    }
  }
};
</script>